export default __webpack_public_path__ + "static/media/clothing_jacket.2ca215ce.svg";